import { useState, useRef, useCallback } from 'react'
import { Outlet } from 'react-router'
import AdminSidebar from './AdminSidebar'
import AdminHeader from './AdminHeader'
import MobileBottomNav from './MobileBottomNav'
import { ADMIN_FACELIFT_CONFIG } from '@/lib/routes/admin-appearance-helpers'

export default function AdminLayout() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false)
  const openerRef = useRef<HTMLButtonElement>(null)

  const handleCloseNav = useCallback(() => {
    setMobileNavOpen(false)
    // Restore focus to opener when drawer closes
    setTimeout(() => openerRef.current?.focus(), 0)
  }, [])

  const shellStyle = {
    '--admin-sidebar-width': `${ADMIN_FACELIFT_CONFIG.sidebarWidth}px`,
    '--admin-header-height': `${ADMIN_FACELIFT_CONFIG.headerHeight}px`,
    '--admin-outer-gap': `${ADMIN_FACELIFT_CONFIG.outerGap}px`,
    '--admin-content-max-width': ADMIN_FACELIFT_CONFIG.contentMaxWidth,
  } as React.CSSProperties

  return (
    <div
      data-testid="admin-layout-shell"
      data-layout-type={ADMIN_FACELIFT_CONFIG.layout}
      data-theme-schema={ADMIN_FACELIFT_CONFIG.themeSchema}
      data-color-mode={ADMIN_FACELIFT_CONFIG.mode}
      style={shellStyle}
      className="flex min-h-screen bg-[hsl(var(--sidebar))]"
    >
      <AdminSidebar mobileOpen={mobileNavOpen} onClose={handleCloseNav} />
      <div className="min-w-0 flex-1 p-[var(--admin-outer-gap)]">
        <div
          data-testid="admin-layout-canvas"
          className="mx-auto flex min-h-[calc(100vh-(var(--admin-outer-gap)*2))] w-full max-w-[var(--admin-content-max-width)] flex-col overflow-hidden rounded-[28px] bg-card shadow-xl"
        >
          <AdminHeader
            onOpenNavigation={() => setMobileNavOpen(true)}
            openerRef={openerRef}
          />
          <main
            data-testid="admin-layout-content"
            className="scrollbar-gutter-stable min-h-0 flex-1 overflow-auto bg-background/80 px-6 pb-20 pt-6 md:pb-6"
          >
            <Outlet />
          </main>
        </div>
      </div>
      <MobileBottomNav onMoreClick={() => setMobileNavOpen(true)} />
    </div>
  )
}
